<template>
    <BaseButton :class="' p-0 mr-2 btn-custom-action-app'"
        :custom-class="`btn-sm btn--custom--style btn-edit-style p-0 m-0 custom-btn-list ${customClass}`"
        :variant="variant" :disabled="disabled" @click="$emit('click', $event)">
        <IconsAction :bg="bg" :url="iconUrl" :alt="alt" />
    </BaseButton>
</template>

<script>
import BaseButton from '@/components/FormControls/BaseButton.vue';
import IconsAction from '@/components/Icons/IconsAction.vue';

export default {
    name: 'AppActionBase',
    components: { BaseButton, IconsAction },
    props: {
        bg: {
            type: String,
            default: 'white'
        },
        iconUrl: {
            type: String,
            required: true
        },
        alt: {
            type: String,
            required: true
        },
        customClass: {
            type: String,
            default: 'btn-sm btn--custom--style custom-btn-list p-0 m-0'
        },
        variant: {
            type: String,
            default: 'default'
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: ['click']
}
</script>
<style scoped>
.w-content {
    min-width: fit-content !important;
}
</style>